<template>
    <div>
        <DCard
            padding
        >
            <ContractPhasesForm
                ref="createForm"
                :errors="errors"
                :contract="contract"
                :active-product-id="contractPhase.product.id"
                :customer-id="customer.id"
                :contract-phase="contractPhase"
                :billing-cycles="billingCycles"
                :contract-term-units="contractTermUnits"
                :discount-types="discountTypes"
                :is-domain-contract="isDomainContract"
                @submit="storeContractPhase"
            />
        </DCard>
    </div>
</template>

<script>
import CustomerBase from '~@/Pages/Customers/Base'
import App from '~@/App.vue'

import ContractPhasesForm from '~@/Components/Customers/Contracts/Phases/Form'

export default {
    name: 'CustomerContractPhaseCreate',
    components: {
        ContractPhasesForm
    },
    layout: [App, CustomerBase],
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        contract: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        contractPhase: {
            type: Object,
            default: () => { return {} }
        },
        billingCycles: {
            type: Array,
            default: () => { return [] }
        },
        contractTermUnits: {
            type: Array,
            default: () => { return [] }
        },
        discountTypes: {
            type: Array,
            default: () => { return [] }
        },
        isDomainContract: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        storeContractPhase (form) {
            form.post(this.$route('customers.customers.contracts.phases.store', {
                customer: this.customer.id,
                contract: this.contract.id
            }))
        }
    }
}
</script>
